<template>
  <div class="pt-page">

    <!-- Hero -->
    <div class="pt-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-table-check</v-icon>
        </v-avatar>
        <div>
          <div class="pt-hero__title">Planes de pagos predefinidos</div>
          <div class="pt-hero__sub">Plantillas de planes de pago por unidad de negocio</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;">
        <v-chip small color="rgba(255,255,255,0.15)" dark>
          <v-icon left small>mdi-school-outline</v-icon> Programas
        </v-chip>
        <v-btn small dark text @click="$router.back()">
          <v-icon left small>mdi-arrow-left</v-icon> Volver
        </v-btn>
      </div>
    </div>

    <div class="pt-body">

      <v-card outlined class="pt-table-card">

        <!-- Toolbar -->
        <div class="pt-table-toolbar px-4 py-2 d-flex align-center flex-wrap" style="gap:8px;">
          <v-chip x-small :color="desserts.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ desserts.length }} plantilla{{ desserts.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" class="mr-1" />
          <v-btn color="indigo darken-1" dark depressed small @click="openregistrar()">
            <v-icon left small>mdi-plus</v-icon> Agregar
          </v-btn>
        </div>

        <v-divider />

        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          loading-text="Cargando planes..."
          no-data-text="Sin planes predefinidos para esta unidad."
          dense
          class="pt-table"
        >
          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label
              :color="item.estado == null ? 'grey lighten-3' : item.estado ? 'green lighten-5' : 'red lighten-5'"
              :class="item.estado == null ? 'grey--text' : item.estado ? 'green--text text--darken-2' : 'red--text text--darken-2'">
              <v-icon left x-small>{{ item.estado ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}</v-icon>
              {{ item.estado ? 'Activo' : 'Inactivo' }}
            </v-chip>
          </template>

          <!-- Conceptos -->
          <template v-slot:[`item.conceptos`]="{ item }">
            <div v-for="(c, ind) in item.conceptos" :key="ind" class="pt-concepto">
              <v-chip x-small label color="indigo lighten-5" class="indigo--text text--darken-2 mr-1">{{ c.max_cuotas }}</v-chip>
              {{ c.nombre }}
            </div>
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <div class="d-flex align-center" style="gap:4px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="indigo darken-1" v-bind="attrs" v-on="on" @click="veritem(item)">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="orange darken-1" v-bind="attrs" v-on="on" @click="moditem(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar plan</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="red darken-1" v-bind="attrs" v-on="on" @click="prerevertir(item)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>

      </v-card>
    </div>

    <Registrar ref="registrarref" v-on:onreg="onreg" />
    <Modificar ref="modificarref" v-on:onreg="onreg" />
    <Ver ref="verref" />
  </div>
</template>

<script>
import xaxios from '@/xaxios';
import Registrar from '@/views/programas/plan-template-add.vue';
import Modificar from '@/views/programas/plan-template-mod.vue';
import Ver from '@/views/programas/plan-template-view.vue';

export default {
  data: () => ({
    loading: false,
    programa_name: '',
    headers: [
      { text: 'Nro',              value: 'nro',              width: 60 },
      { text: 'Nombre',           value: 'nombre' },
      { text: 'Unidad negocio',   value: 'unidad_negocio_id', width: 130 },
      { text: 'Estado',           value: 'estado',            width: 100 },
      { text: 'Conceptos',        value: 'conceptos' },
      { text: 'Opciones',         value: 'opciones',          width: 100, sortable: false },
    ],
    desserts: [],
  }),
  components: { Registrar, Ver, Modificar },
  watch: {
    '$store.state.CARGO.sede': function() {
      this.listar();
    },
  },
  methods: {
    openregistrar() {
      this.$refs.registrarref.openmodal();
    },
    listar() {
      this.loading = true;
      this.desserts = [];
      let unidad = this.$store.state.CARGO.sede.unidad_negocio;
      window.console.log(this.$store.state.CARGO);
      let vue = this;
      var config = {
        method: 'get',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos?unidadnegocio=${unidad}`,
        headers: {},
      };
      xaxios.request(config)
        .then(function(response) {
          let data = response.data.data;
          data = data.reverse();
          data.map((x, i) => { x.nro = i + 1; });
          window.console.log(data);
          vue.desserts = data;
          vue.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
          vue.loading = false;
        });
    },
    onreg() {
      this.listar();
    },
    veritem(item) {
      this.$refs.verref.openmodal(item);
    },
    moditem(item) {
      this.$refs.modificarref.openmodal(item);
    },
    async prerevertir(item) {
      let message = { title: 'Confirmación necesaria:', body: '' };
      var opt = {
        verification: 'eliminar',
        verificationHelp: 'Escriba "[+:verification]" para proceder.',
        okText: 'Proceder',
        cancelText: 'Cancelar',
        backdropClose: false,
        animation: 'bounce',
        loader: true,
        type: 'hard',
      };
      let dialogo = await this.$dialog
        .confirm(message, opt)
        .then((dialog) => dialog)
        .catch(() => {});
      if (!dialogo) return;

      var config = {
        method: 'delete',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos/${item.id}`,
        headers: { 'Content-Type': 'application/json' },
      };
      xaxios.request(config)
        .then(({ data }) => {
          window.console.log(data);
          this.listar();
          dialogo.close();
        })
        .catch((e) => {
          window.console.log(e);
          dialogo.close();
        });
    },
  },
  mounted() {
    this.listar();
  },
};
</script>

<style scoped>
.pt-page { min-height: 100vh; background: #f5f7fa; }

.pt-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pt-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.pt-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.pt-body { padding: 20px 24px; }

.pt-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.pt-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.pt-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.pt-table >>> tbody tr:hover { background: #f0f4ff !important; }
.pt-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}

.pt-concepto {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8rem;
  line-height: 1.8;
}
</style>
